import { useCms } from "./useCms";
import { Field, Panel } from "./Fields";
import { SEO_PAGES } from "@/lib/homeDefaults";

export default function SeoEditor() {
  const { data, setData, save, saving } = useCms("site", {});
  const seo = data.seo || {};
  const set = (path, k, v) => setData({ ...data, seo: { ...seo, [path]: { ...(seo[path] || {}), [k]: v } } });

  return (
    <Panel title="SEO — Titles & Meta Descriptions" description="Leave blank to keep the built-in optimized value. Titles ~50–60 chars, descriptions 150–160 chars." onSave={() => save(data)} saving={saving} saveTestid="seo-save">
      <div className="space-y-4">
        {SEO_PAGES.map(([path, label]) => {
          const v = seo[path] || {};
          return (
            <div key={path} data-testid={`seo-row-${path}`} className="rounded-xl border border-slate-200 p-4">
              <p className="text-sm font-semibold text-slate-900 mb-2">{label} <span className="font-mono text-xs text-slate-500 ml-2">{path}</span></p>
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <Field label={`SEO title (${(v.title || "").length} chars)`} value={v.title} onChange={(x) => set(path, "title", x)} testid={`seo-title-${path}`} placeholder="Built-in title" />
                </div>
                <div>
                  <Field label={`Meta description (${(v.description || "").length} chars)`} multiline value={v.description} onChange={(x) => set(path, "description", x)} testid={`seo-desc-${path}`} placeholder="Built-in description" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
